import * as React from 'react';
import { useCustomSearchParams } from 'common/hooks/customSearchParams';
import { WATCH_LIST_QUERY_PARAMS } from 'pages/TrackAndTrace/constants';
import { ContainerSearch } from 'components/PillSearch';
import { triggerPickupScraping } from 'services/clients/watchList';

/**
 * Renders an input for searching through the available containers
 * @returns
 */
export const Search: React.FC = () => {
  const { searchParams, setSearchParams } = useCustomSearchParams(WATCH_LIST_QUERY_PARAMS, true);

  const onSearch = React.useCallback(
    (containerNumbers: string[]) => {
      setSearchParams(
        {
          containerNumbers,
        },
        false
      );
      if (containerNumbers.length > 0) triggerPickupScraping(containerNumbers);
    },
    [setSearchParams]
  );

  return <ContainerSearch onSearch={onSearch} containerNumbers={searchParams.containerNumbers} />;
};
Search.displayName = 'TrackAndTrace.Controls.Search';
